export default __webpack_public_path__ + "static/scalpel-23adc5646e29b121e91f62694656befc.png";